import React, { Component } from 'react';
import service from '../../core/service';
import * as yup from 'yup'
import { fixNumbers, numberWithCommas, parsePersianDate, toFarsiNumber } from '../../core/utils';
import { inqueryDataa , isEqual} from '../../Redux/services/generalService';
import { toast } from 'react-toastify';
import persian_fa from "react-date-object/locales/persian_fa";
import axios from 'axios';
import { AppConstants } from '../../core/constants';
import Cookies from 'js-cookie';
import { DateObject } from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian"
interface IProps {
  dispatch?: any,
  userData?:any;

}

interface IState {
  str: string;
  value2: string,
  openModal: boolean,
  startValue: string;
  open: any,
  anchorEl: null | HTMLElement;
  step: number;
  insuranceType: string;
  limitationInquiry: any;
  allLimitationInquiry: any;
  contentLoading: boolean;

  //
  openMenu: boolean;

  jobListHolder: any;
  jobListHolderLoading: boolean;

  jobListInquiry: any;
  jobListInquiryLoading: boolean;


  extrarisk: any;

  contract_id: "";
  // 1
  step1Errors: any,
  holder_birthday: any;
  insured_birthday: any;
  policy_holder_job_category: string;
  insured_job_category: string;

  policy_holder_job_category_title: string;
  insured_job_category_title: string;
  policy_holder_extra_dangers: string;
  insurred_extra_dangers: string;
  selfsame: boolean;


  // 2
  step2Errors: any,
  saveing: string;
  premium_annually: string;
  payment_duration: string;
  duration: string;
  adjustment_coefficient_permium: string;

  decuple_coverages_premium:string;

  // 3
  step3Errors: any,
  start_death_asset: string;
  adjustment_coefficient_death_benefit: string;
  has_cancer_diagnosis: any;
  cancer_coverage: any;
  has_supplementary_special_diseases_coverage: any;
  accident_medical_cost_coverage: any;
  temporary_and_permanent_disability_coverage: any;
  accident_death_coverage: string;

  has_hos_benefit_coverage: any;
  main_special_diseases_coverage: any;
  has_temporary_disability_coverage: any;
  payment_method: any;
  has_waiver_diseases_policy_holder: string;
  has_waiver_accident_policy_holder: string;
  // 4
  step4Errors: any,
  annuity_disability_coverage_disease: string;
  annuity_disability_coverage_accident: string;
  //
  medical_extra_rate_percent: any;
  policy_holder_medical_extra: any,
  paymentMethodList: any;
  result: any;

  currentPage: number,
  handleMobileStep1: boolean;
  tab?: number;
  showInfo: boolean;
  showUpdateMOdal: boolean;
  isEdited?: boolean;


  data?: any
  options?: any,
  inputValue: any;
  openContractNumberModal: boolean;
  contractSelected: string;
  contractNumberErrors: any;
  base64Loading: boolean;
  minimum_insurance_premium:string; 

}

export class InqueryController extends Component<IProps, IState> {
  datePickerRefHolder: any;
  datePickerRefInsured: any;
  digits:any;

  constructor(props: any) {
    super(props);
    this.datePickerRefHolder = React.createRef();
    this.datePickerRefInsured = React.createRef();
    this.digits = persian_fa.digits
  }


  state: IState = {
    open: false,
    str: "",
    value2: "",
    openModal: false,
    startValue: "",
    anchorEl: null,
    step: 1,
    insuranceType: "Universal",
    limitationInquiry: [],
  allLimitationInquiry: [],
    contract_id: "",
    openMenu: false,
    // 
    jobListHolder: [],
    jobListHolderLoading: false,

    jobListInquiry: [],
    jobListInquiryLoading: false,


    extrarisk: [],
    contentLoading: false,
    // 1
    step1Errors: [],
    holder_birthday: new DateObject({ calendar: persian }).subtract(18, "years"),
    insured_birthday: "",
    policy_holder_job_category: "",
    insured_job_category: "",

    policy_holder_job_category_title: "",
    insured_job_category_title: "",

    policy_holder_extra_dangers: "",
    insurred_extra_dangers: "",
    selfsame: false,
    // 2
    step2Errors: [],
    saveing: "",
    payment_duration: "",
    duration: "",
    adjustment_coefficient_permium: "",
    decuple_coverages_premium:"",
    premium_annually: "",
    // 3
    step3Errors: [],
    adjustment_coefficient_death_benefit: "",
    start_death_asset: "",
    has_cancer_diagnosis: "",
    cancer_coverage: "",
    has_supplementary_special_diseases_coverage: "",
    accident_medical_cost_coverage: "",
    temporary_and_permanent_disability_coverage: "",
    has_hos_benefit_coverage: "",
    main_special_diseases_coverage: "",
    accident_death_coverage: "",

    has_temporary_disability_coverage: "",
    payment_method: 0,
    has_waiver_diseases_policy_holder: "",
    has_waiver_accident_policy_holder: "",
    // 4
    step4Errors: [],
    annuity_disability_coverage_disease: "",
    annuity_disability_coverage_accident: "",

    paymentMethodList: [],
    medical_extra_rate_percent: "",
    policy_holder_medical_extra: "",
    result: [],
    currentPage: 0,
    handleMobileStep1: false,
    tab: 0,
    showInfo: false,
    showUpdateMOdal: false,
    isEdited: false,

    data: {
      labels: [],
      datasets: [

      ]
    },

    options: {

    },    
        inputValue:" ",
    openContractNumberModal: true,
    contractSelected: "0",
    contractNumberErrors: [],
    base64Loading: false,
  minimum_insurance_premium:"",

  };
  id: any = this.state.open ? 'simple-popper' : undefined;

  search = async (e: any) => {
    this.setState({ str: e })
  };

  handleChangeHolderBD = (value: any) => {
    this.setState({ holder_birthday: value })
    if (this.state.selfsame) {
      this.setState({
        insured_birthday: value,
      })
    }
  };
  handleChangeInsuredBD = (value: any) => {
    this.setState({ insured_birthday: value })
    if (this.state.selfsame) {
      this.setState({
        holder_birthday: value,
      })
    }

  };
  // onChange = (field:string, value:any) => {
  //   this.setState({...this.state ,[field]: value});
  // }

  // handleChangeValue = (e: any) => {
  //   this.setState({ value2: e.target.value })
  // };
  changeDangerHolder = (e: string) => {
    this.setState({ policy_holder_extra_dangers: e })
    // if (this.state.selfsame) {
    //   this.setState({
    //     insurred_extra_dangers: e,
    //   })
    // }

  }
  changeJobHolder = (e: any) => {
    this.setState({ policy_holder_job_category: e.value, policy_holder_job_category_title: e.title })


    if (this.state.selfsame) {
      this.setState({


        insured_job_category: e.value,
        insured_job_category_title: e.title,


      })
    }

  }
  changeDangerInsured = (e: string) => {
    this.setState({ insurred_extra_dangers: e })
    if (this.state.selfsame) {
      this.setState({
        policy_holder_extra_dangers: e,
      })
    }

  }
  changeJobInsured = (e: any) => {
    this.setState({ insured_job_category: e.value, insured_job_category_title: e.title })
    if (this.state.selfsame) {
      this.setState({
        policy_holder_job_category: e.value,
        policy_holder_job_category_title: e.title,

      })
    }

  }
  handleClick = (event: any) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget });
    this.setState({ open: this.state.anchorEl ? null : Boolean(event.currentTarget) });

  };


  increaseSteper = (type: boolean) => {
    if (this.state.step === 1) {
      this.checkStep1(type)
    }
    if (this.state.step === 2) {
      this.checkStep2(type)
    }
    if (this.state.step === 3) {
      this.checkStep3(type)
    }
    if (this.state.step === 4) {
      this.checkStep4()
    }
    // this.setState({ step: this.state.step + 1 })
  }
  decreaseSteper = () => {
    if (this.state.step > 1)
      this.setState({ step: this.state.step - 1 })
  }

  decreaseSteper2 = () => {
    if (this.state.step === 1 && this.state.handleMobileStep1) {
      this.setState({ handleMobileStep1: false })

    }
  }
  getLimitationInquery = async () => {
    this.setState({ contentLoading: true })

    try {

      let response;
  
      
        const { contract_id, insuranceType } = this.state;
        response = contract_id
       ? await service.limitationInquiry.limitation2(insuranceType, contract_id)
       : await service.limitationInquiry.limitation(insuranceType);

       
       if (response) {
         this.setState({ contentLoading: false })
         this.setState({openContractNumberModal : false})
         
         const data =  response.data.data?.data.defaults_once
         const findDefault = (name:string) => data.filter((item:any) => item.name === name)[0]?.default;
        this.setState({
          // return response;
          limitationInquiry: response.data.data?.data?.defaults_once,
          allLimitationInquiry:response.data.data?.data,
          contract_id: response.data.data?.data?.contract_once_id,
          // return response;

          // holder_birthday:findDefault("holder_birthday")[0]?.default || this.state.currentDate,
          // insured_birthday:findDefault("insured_birthday")[0]?.default,
          // policy_holder_job_category:findDefault("policy_holder_job_category")[0]?.default || "",
          // insured_job_category:findDefault("insured_job_category")[0]?.default || "",
          policy_holder_extra_dangers:findDefault("policy_holder_extra_dangers") || "",
          insurred_extra_dangers:findDefault("insurred_extra_dangers") || "",

          // 2
          saveing:findDefault("saveing"),
          payment_duration:findDefault("payment_duration"),
          duration:findDefault("duration"),
          adjustment_coefficient_permium:findDefault("adjustment_coefficient_permium"),
          decuple_coverages_premium:findDefault("decuple_coverages_premium") ,
          premium_annually:findDefault("premium_annually"),
          // 3
          adjustment_coefficient_death_benefit:findDefault("adjustment_coefficient_death_benefit"),
          accident_death_coverage:findDefault("accident_death_coverage"),
          start_death_asset:findDefault("start_death_asset"),
          has_cancer_diagnosis:findDefault("has_cancer_diagnosis"),
          cancer_coverage:findDefault("cancer_coverage"),
          has_supplementary_special_diseases_coverage:findDefault("has_supplementary_special_diseases_coverage"),
          accident_medical_cost_coverage:findDefault("accident_medical_cost_coverage"),
          temporary_and_permanent_disability_coverage:findDefault("temporary_and_permanent_disability_coverage"),
          has_hos_benefit_coverage:findDefault("has_hos_benefit_coverage"),
          main_special_diseases_coverage:findDefault("main_special_diseases_coverage"),
          has_temporary_disability_coverage:findDefault("has_temporary_disability_coverage"),
          has_waiver_diseases_policy_holder:findDefault("has_waiver_diseases_policy_holder"),
          has_waiver_accident_policy_holder:findDefault("has_waiver_accident_policy_holder"),

          // 4
          annuity_disability_coverage_accident:findDefault("annuity_disability_coverage_accident"),
          annuity_disability_coverage_disease:findDefault("annuity_disability_coverage_disease"),
          //
          medical_extra_rate_percent:findDefault("medical_extra_rate_percent"),
          policy_holder_medical_extra:findDefault("policy_holder_medical_extra"),
          // payment_method:data.filter((item: { name: string; }) => item.name === "payment_method")
          minimum_insurance_premium:findDefault("minimum_insurance_premium"),

        })
  }
        this.getExtrarisk();
        this.getPaymentList();

          this.setState({ step: this.state.step + 1 })

    } catch (error:any) {
      this.setState({ contentLoading: false })
      if(error?.status === 400){
        toast.error("قرارداد یافت نشد")
      }
      // throw error;
    }
  };

  getDefaultInquery = async (isEdit?:boolean) => {
    this.setState({ contentLoading: true })

    try {

      const contractId = window.location.pathname.split("/")[2];
      let response;
  
        response = await service.limitationInquiry.inqueryDefault(contractId);
        if (response) {
          
          this.setState({ contentLoading: false })
        this.setState({openContractNumberModal : false})


        const  defaults = response.data.data?.data;
        const data = defaults?.contract_anually
          ? defaults.defaults_anually
          : defaults.defaults_once;

          const findDefault = (name:string) => data.filter((item:any) => item.name === name)[0]?.default;

          this.setState({
            // return response;
            limitationInquiry: data,
            allLimitationInquiry:response.data.data?.data,
            contract_id: defaults?.contract_anually
            ? defaults.contract_anually
            : defaults?.contract_once_id,
            // return response;
            selfsame:findDefault("insuredEqualPolicyHolder"),
  
            holder_birthday: parsePersianDate(findDefault("policy_holder_birth_date")) || "",
            insured_birthday: parsePersianDate(findDefault("insured_birth_date")),

            policy_holder_job_category: findDefault("policy_holder_job")?.id || "",
            policy_holder_job_category_title: findDefault("policy_holder_job")?.job_title || "",

            
            insured_job_category: findDefault("insured_job")?.id || "",
            insured_job_category_title: findDefault("insured_job")?.job_title || "",


            policy_holder_extra_dangers: findDefault("policy_holder_extra_dangers") || "",
            insurred_extra_dangers: findDefault("insurred_extra_dangers") || "",
            // 2
            saveing: findDefault("saveing"),
            payment_duration: findDefault("payment_duration"),
            duration: findDefault("duration"),
            adjustment_coefficient_permium: findDefault("adjustment_coefficient_permium"),
            decuple_coverages_premium: findDefault("decuple_coverages_premium") ,
            premium_annually: findDefault("premium_annually"),
            // 3
            adjustment_coefficient_death_benefit: findDefault("adjustment_coefficient_death_benefit"),
            accident_death_coverage: findDefault("accident_death_coverage"),
            start_death_asset: findDefault("start_death_asset"),
            has_cancer_diagnosis: findDefault("has_cancer_diagnosis"),
            cancer_coverage: findDefault("cancer_coverage"),
            has_supplementary_special_diseases_coverage: findDefault("has_supplementary_special_diseases_coverage"),
            accident_medical_cost_coverage: findDefault("accident_medical_cost_coverage"),
            temporary_and_permanent_disability_coverage: findDefault("temporary_and_permanent_disability_coverage"),
            has_hos_benefit_coverage: findDefault("has_hos_benefit_coverage"),
            main_special_diseases_coverage: findDefault("main_special_diseases_coverage"),
            has_temporary_disability_coverage: findDefault("has_temporary_disability_coverage"),
            has_waiver_diseases_policy_holder: findDefault("has_waiver_diseases_policy_holder"),
            has_waiver_accident_policy_holder: findDefault("has_waiver_accident_policy_holder"),
  
            // 4
            annuity_disability_coverage_accident: findDefault("annuity_disability_coverage_accident"),
            annuity_disability_coverage_disease: findDefault("annuity_disability_coverage_disease"),
            //
            medical_extra_rate_percent: findDefault("medical_extra_rate_percent"),
            policy_holder_medical_extra: findDefault("policy_holder_medical_extra"),
            // payment_method:findDefault("payment_method")
            minimum_insurance_premium:findDefault("minimum_insurance_premium"),
  
          })
        
      } 
        this.getExtrarisk();
        this.getPaymentList();

    } catch (error:any) {
      this.setState({ contentLoading: false })
      if(error?.status === 400){
        toast.error("قرارداد یافت نشد")
      }
      // throw error;
    }
  };


  searchTimeoutH: string | number | NodeJS.Timeout | undefined;
  getJobHolder = (e: any) => {
    this.setState({ jobListHolderLoading: true })
    clearTimeout(this.searchTimeoutH);
    this.searchTimeoutH = setTimeout(async () => {
      try {
        const response = await service.limitationInquiry.job(e);
        if (response) {
          this.setState({ jobListHolder: response.data.data?.data?.list, jobListHolderLoading: false })

          // return response;
        } else {
          this.setState({ jobListHolderLoading: false })

        }
      } catch (error) {
        // throw error;
      }
    }, 1000);
  };


  searchTimeout: string | number | NodeJS.Timeout | undefined;
  getJobInquiry = (e: any) => {
    this.setState({ jobListInquiryLoading: true })
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(async () => {
      try {
        const response = await service.limitationInquiry.job(e);
        if (response) {
          this.setState({ jobListInquiry: response.data.data?.data?.list, jobListInquiryLoading: false })

          // return response;
        } else {
          this.setState({ jobListInquiryLoading: false })

        }
      } catch (error) {
        // throw error;
      }
    }, 1000);
  };
  getPaymentList = async () => {
    const { contract_id } = this.state;

    let parameters = {
      contract_id: contract_id ? contract_id : null,
    };
  
    const params = new URLSearchParams();
  
    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        params.append(key, value);
      }
    }
    try {
      const response = await service.limitationInquiry.paymentList(params.toString());
      if (response) {
        this.setState({ paymentMethodList: response?.data?.data?.data })

        // return response;
      }
    } catch (error) {
      // throw error;
    }
  };

  handleChangePayment = (e: any) => {
    const data =  e.target.value === 0 ? this.state.allLimitationInquiry.defaults_once : this.state.allLimitationInquiry.defaults_anually
    
    this.setState({ payment_method: e.target.value , limitationInquiry : data , 







    contract_id: e.target.value === 0 ? this.state.allLimitationInquiry?.contract_once_id : this.state.allLimitationInquiry?.contract_anually,
    // return response;

    // holder_birthday: data.filter((item: { name: string; }) => item.name === "holder_birthday")[0]?.default || this.state.currentDate,
    // insured_birthday: data.filter((item: { name: string; }) => item.name === "insured_birthday")[0]?.default,
    // policy_holder_job_category: data.filter((item: { name: string; }) => item.name === "policy_holder_job_category")[0]?.default || "",
    // insured_job_category: data.filter((item: { name: string; }) => item.name === "insured_job_category")[0]?.default || "",
    // policy_holder_extra_dangers: data.filter((item: { name: string; }) => item.name === "policy_holder_extra_dangers")[0]?.default || "",
    // insurred_extra_dangers: data.filter((item: { name: string; }) => item.name === "insurred_extra_dangers")[0]?.default || "",

    // 2
    saveing: data.filter((item: { name: string; }) => item.name === "saveing")[0]?.default,
    payment_duration: data.filter((item: { name: string; }) => item.name === "payment_duration")[0]?.default,
    duration: data.filter((item: { name: string; }) => item.name === "duration")[0]?.default,
    adjustment_coefficient_permium: data.filter((item: { name: string; }) => item.name === "adjustment_coefficient_permium")[0]?.default,
    decuple_coverages_premium: data.filter((item: { name: string; }) => item.name === "decuple_coverages_premium")[0]?.default ,
    premium_annually: data.filter((item: { name: string; }) => item.name === "premium_annually")[0]?.default,
    // 3
    adjustment_coefficient_death_benefit: data.filter((item: { name: string; }) => item.name === "adjustment_coefficient_death_benefit")[0]?.default,
    accident_death_coverage: data.filter((item: { name: string; }) => item.name === "accident_death_coverage")[0]?.default,
    start_death_asset: data.filter((item: { name: string; }) => item.name === "start_death_asset")[0]?.default,
    has_cancer_diagnosis: data.filter((item: { name: string; }) => item.name === "has_cancer_diagnosis")[0]?.default,
    cancer_coverage: data.filter((item: { name: string; }) => item.name === "cancer_coverage")[0]?.default,
    has_supplementary_special_diseases_coverage: data.filter((item: { name: string; }) => item.name === "has_supplementary_special_diseases_coverage")[0]?.default,
    accident_medical_cost_coverage: data.filter((item: { name: string; }) => item.name === "accident_medical_cost_coverage")[0]?.default,
    temporary_and_permanent_disability_coverage: data.filter((item: { name: string; }) => item.name === "temporary_and_permanent_disability_coverage")[0]?.default,
    has_hos_benefit_coverage: data.filter((item: { name: string; }) => item.name === "has_hos_benefit_coverage")[0]?.default,
    main_special_diseases_coverage: data.filter((item: { name: string; }) => item.name === "main_special_diseases_coverage")[0]?.default,
    has_temporary_disability_coverage: data.filter((item: { name: string; }) => item.name === "has_temporary_disability_coverage")[0]?.default,
    has_waiver_diseases_policy_holder: data.filter((item: { name: string; }) => item.name === "has_waiver_diseases_policy_holder")[0]?.default,
    has_waiver_accident_policy_holder: data.filter((item: { name: string; }) => item.name === "has_waiver_accident_policy_holder")[0]?.default,

    // 4
    annuity_disability_coverage_accident: data.filter((item: { name: string; }) => item.name === "annuity_disability_coverage_accident")[0]?.default,
    annuity_disability_coverage_disease: data.filter((item: { name: string; }) => item.name === "annuity_disability_coverage_disease")[0]?.default,
    //
    medical_extra_rate_percent: data.filter((item: { name: string; }) => item.name === "medical_extra_rate_percent")[0]?.default,
    policy_holder_medical_extra: data.filter((item: { name: string; }) => item.name === "policy_holder_medical_extra")[0]?.default,
    // payment_method:data.filter((item: { name: string; }) => item.name === "payment_method")[0]?.default
  })
  }

  getExtrarisk = async () => {
    try {
      const response = await service.limitationInquiry.extrarisk();
      if (response) {
        this.setState({
          extrarisk: response.data.data?.data?.list,

          policy_holder_extra_dangers: response.data.data?.data?.list[0].value,
          insurred_extra_dangers: response.data.data?.data?.list[0].value,

          
        })

        // return response;
      }
    } catch (error) {
      // throw error;
    }
  };
  selfsame = (e: any) => {
    this.setState({ selfsame: e.target.checked })

    if (e.target.checked) {
      this.setState({
        // holder_birthday: ,
        insured_birthday: this.state.holder_birthday,
        // policy_holder_job_category,
        insured_job_category: this.state.policy_holder_job_category,
        insured_job_category_title: this.state.policy_holder_job_category_title,

        // policy_holder_extra_dangers,
        policy_holder_extra_dangers: this.state.insurred_extra_dangers,
      })
    } else {
      this.setState({
        // insured_birthday: "",
        // insured_job_category: "",
        // insured_job_category_title: "",
        // insurred_extra_dangers: "",
      })
    }
  }

  findMinLimitation = (field: string) => {
    const { limitationInquiry } = this.state;
    let min = limitationInquiry.filter((item: { name: string; }) => item.name === field)[0]?.min;
    if (min) {
      return Number(min)
    } else {
      return Number(0)
    }
  }
  findMaxLimitation = (field: string) => {
    const { limitationInquiry } = this.state;
    // let max = limitationInquiry.find((el: { [x: string]: any; }) => el[field])?.max;
    let max = limitationInquiry.filter((item: { name: string; }) => item.name === field)[0]?.max
    if (max) {
      return Number(max)
    } else {
      return Number(10000000000)
    }
  }
  async checkStep1(type: boolean) {

    const { holder_birthday, policy_holder_job_category , insured_birthday, insured_job_category , contract_id} = this.state;
    const shebaCodeSchema = yup.object({
      holder_birthday: yup.string().required("تاریخ تولد اجباری می باشد"),
      policy_holder_job_category: yup.string().required("شغل اجباری می باشد"),
      contract_id: yup.string().when('$condition', (condition, schema) =>
        contract_id !== "" ?
          schema.required("شماره قرارداد اجباری می‌باشد").min(3, "شماره قرارداد نمی‌تواند کمتر از 3 کاراکتر باشد").max(10, "شماره قرارداد نمی‌تواند بیشتر از 10 کاراکتر باشد") : schema
      ),
      // policy_holder_extra_dangers: yup.string().required("خطرات اضافه بیمه گذار اجباری می باشد"),
      insured_birthday: yup.string().required("تاریخ تولد اجباری می باشد"),
      insured_job_category: yup.string().required("شغل اجباری می باشد"),
      // insurred_extra_dangers: yup.string().required("خطرات اضافه بیمه شده اجباری می باشد"),
    });
    try {
      await shebaCodeSchema.validate({ holder_birthday,contract_id, policy_holder_job_category , insured_birthday, insured_job_category }, { abortEarly: false });
      if (!window.location.pathname.split("/")[2]) {
      if (type) {
        this.getLimitationInquery();
      } else {
        this.createInquery();
      }
      } else {
                this.setState({ step: this.state.step + 1 })
      }
      this.setState({ step1Errors: [] })
    } catch (err: any) {
      this.setState({ step1Errors: err.inner })
    }
  };
  async checkStep2(type: boolean) {
    const { saveing, premium_annually, adjustment_coefficient_permium, duration, payment_duration, payment_method , decuple_coverages_premium } = this.state;
    const shebaCodeSchema = yup.object({
      saveing: yup.string().required("  آورده اولیه اجباری می باشد")
        .test("saveing", `آورده اولیه نمیتواند کمتر از ${this.findMinLimitation("saveing")} ریال و بیشتر از ${this.findMaxLimitation("saveing")} ریال باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("saveing") || Number(value) > this.findMaxLimitation("saveing")) {
              return false;
            } else {
              return true
            }

          }),
      payment_method: yup.string().required("  نحوه پرداخت اجباری می باشد"),


      premium_annually: yup.string().required("حق بیمه سال اول اجباری می باشد")
        .test("premium_annually", `حق بیمه سال اول نمیتواند کمتر از ${this.findMinLimitation("premium_annually")} ریال و بیشتر از ${this.findMaxLimitation("premium_annually")} ریال باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("premium_annually") || Number(value) > this.findMaxLimitation("premium_annually")) {
              return false;
            } else {
              return true
            }

          }),
          decuple_coverages_premium: yup.string().required(" اجباری می باشد"),

      adjustment_coefficient_permium: yup.string().required("ضریب تعدیل حق بیمه سالانه اجباری می باشد")
        .test("adjustment_coefficient_permium", `  نمیتواند کمتر از ${this.findMinLimitation("adjustment_coefficient_permium")}  و بیشتر از ${this.findMaxLimitation("adjustment_coefficient_permium")}  باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("adjustment_coefficient_permium") || Number(value) > this.findMaxLimitation("adjustment_coefficient_permium")) {
              return false;
            } else {
              return true
            }

          }),


      duration: yup.string().required("مدت بیمه اجباری می باشد")
        .test("duration", `  نمیتواند کمتر از ${this.findMinLimitation("duration")}  و بیشتر از ${this.findMaxLimitation("duration")}  باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("duration") || Number(value) > this.findMaxLimitation("duration")) {
              return false;
            } else {
              return true
            }
          }),

      payment_duration: yup.string().required("مدت پرداخت حق بیمه اجباری می باشد")
        .test("payment_duration", `  نمیتواند کمتر از ${this.findMinLimitation("payment_duration")}  و بیشتر از ${this.findMaxLimitation("payment_duration")}  باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("payment_duration") || Number(value) > this.findMaxLimitation("payment_duration")) {
              return false;
            } else {
              return true
            }

          })

        .test("payment_duration", `  مدت پرداخت حق بیمه نمیتواند بیشتر از مدت بیمه باشد   `,
          (value) => {
            if (Number(value) > Number(duration)) {
              return false;
            } else {
              return true
            }

          }),


      // .min(this.findMinLimitation("payment_duration"), `حداقل ${this.findMinLimitation("payment_duration")} کاراکتر می باشد`)
      // .max(this.findMinLimitation("payment_duration"), `حداکثر ${this.findMaxLimitation("payment_duration")} کاراکتر می باشد`),

    });
    try {

      await shebaCodeSchema.validate({ saveing, premium_annually, adjustment_coefficient_permium,decuple_coverages_premium, duration, payment_duration, payment_method }, { abortEarly: false });
      if (type) {
        this.setState({ step: this.state.step + 1 })
      } else {

        this.createInquery();
      }
      this.setState({ step2Errors: [] })


    } catch (err: any) {
      this.setState({ step2Errors: err.inner })
    }
  };
  async checkStep3(type: boolean) {
    const {
      start_death_asset,
      adjustment_coefficient_death_benefit,
      has_cancer_diagnosis,
      cancer_coverage,
      has_supplementary_special_diseases_coverage,
      accident_medical_cost_coverage,
      temporary_and_permanent_disability_coverage,
      accident_death_coverage,
      has_temporary_disability_coverage,
      has_hos_benefit_coverage,
      main_special_diseases_coverage,
      
      annuity_disability_coverage_accident,
      annuity_disability_coverage_disease,
      insurred_extra_dangers,
      // insurred_extra_dangers

    } = this.state;
    const shebaCodeSchema = yup.object({
      insurred_extra_dangers: yup.string().required("خطرات اضافه بیمه شده اجباری می باشد"),

      // insurred_extra_dangers: yup.string().required("خطرات اضافه بیمه شده اجباری می باشد"),
      start_death_asset: yup.string().required("  سرمایه فوت به هر علت اجباری می باشد")
        .test("start_death_asset", `مبلغ پرداختی نمیتواند کمتر از ${this.findMinLimitation("start_death_asset")} ریال و بیشتر از ${this.findMaxLimitation("start_death_asset")} ریال باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("start_death_asset") || Number(value) > this.findMaxLimitation("start_death_asset")) {
              return false;
            } else {
              return true
            }

          }),

      adjustment_coefficient_death_benefit: yup.string()
        .required("ضریب تعدیل سرمایه فوت اجباری می باشد")
        .test("adjustment_coefficient_death_benefit", `  نمیتواند کمتر از ${this.findMinLimitation("adjustment_coefficient_death_benefit")} ریال و بیشتر از ${this.findMaxLimitation("adjustment_coefficient_death_benefit")} ریال باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("adjustment_coefficient_death_benefit") || Number(value) > this.findMaxLimitation("adjustment_coefficient_death_benefit")) {
              return false;
            } else {
              return true
            }

          }),
      has_cancer_diagnosis: yup.string().notRequired(),
      cancer_coverage: yup.string().notRequired()
        .test("cancer_coverage", `  نمیتواند کمتر از ${this.findMinLimitation("cancer_coverage")}  و بیشتر از ${this.findMaxLimitation("cancer_coverage")}  باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("cancer_coverage") || Number(value) > this.findMaxLimitation("cancer_coverage")) {
              return false;
            } else {
              return true
            }

          }),
      has_supplementary_special_diseases_coverage: yup.string().notRequired()
        .test("has_supplementary_special_diseases_coverage", `    نمیتواند کمتر از ${this.findMinLimitation("has_supplementary_special_diseases_coverage")}  و بیشتر از ${this.findMaxLimitation("has_supplementary_special_diseases_coverage")}  باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("has_supplementary_special_diseases_coverage") || Number(value) > this.findMaxLimitation("has_supplementary_special_diseases_coverage")) {
              return false;
            } else {
              return true
            }
          }),
      accident_medical_cost_coverage: yup.string().notRequired()
        .test("accident_medical_cost_coverage", `  نمیتواند کمتر از ${this.findMinLimitation("accident_medical_cost_coverage")}  و بیشتر از ${this.findMaxLimitation("accident_medical_cost_coverage")}  باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("accident_medical_cost_coverage") || Number(value) > this.findMaxLimitation("accident_medical_cost_coverage")) {
              return false;
            } else {
              return true
            }

          }),
      temporary_and_permanent_disability_coverage: yup.string().notRequired()
        .test("temporary_and_permanent_disability_coverage", `      نمیتواند کمتر از ${this.findMinLimitation("temporary_and_permanent_disability_coverage")}  و بیشتر از ${this.findMaxLimitation("temporary_and_permanent_disability_coverage")}  باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("temporary_and_permanent_disability_coverage") || Number(value) > this.findMaxLimitation("temporary_and_permanent_disability_coverage")) {
              return false;
            } else {
              return true
            }

          }),
      accident_death_coverage: yup.string().notRequired()
        .test("accident_death_coverage", `  نمیتواند کمتر از ${this.findMinLimitation("accident_death_coverage")}  و بیشتر از ${this.findMaxLimitation("accident_death_coverage")}  باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("accident_death_coverage") || Number(value) > this.findMaxLimitation("accident_death_coverage")) {
              return false;
            } else {
              return true
            }

          }),
      has_temporary_disability_coverage: yup.string().notRequired(),
      has_hos_benefit_coverage: yup.string().notRequired(),
      main_special_diseases_coverage: yup.string().notRequired()
        .test("main_special_diseases_coverage", `    نمیتواند کمتر از ${this.findMinLimitation("main_special_diseases_coverage")}  و بیشتر از ${this.findMaxLimitation("main_special_diseases_coverage")}  باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("main_special_diseases_coverage") || Number(value) > this.findMaxLimitation("main_special_diseases_coverage")) {
              return false;
            } else {
              return true
            }

          }),
    
      annuity_disability_coverage_accident: yup.string().notRequired(),
      annuity_disability_coverage_disease: yup.string().notRequired()
        .test("annuity_disability_coverage_disease", `       نمیتواند کمتر از ${this.findMinLimitation("annuity_disability_coverage_disease")}  و بیشتر از ${this.findMaxLimitation("annuity_disability_coverage_disease")}  باشد `,
          (value) => {
            if (Number(value) < this.findMinLimitation("annuity_disability_coverage_disease") || Number(value) > this.findMaxLimitation("annuity_disability_coverage_disease")) {
              return false;
            } else {
              return true
            }

          }),
    });
    try {

      await shebaCodeSchema.validate({
        start_death_asset,
        adjustment_coefficient_death_benefit,
        has_cancer_diagnosis,
        cancer_coverage,
        has_supplementary_special_diseases_coverage,
        accident_medical_cost_coverage,
        temporary_and_permanent_disability_coverage,
        accident_death_coverage,
        has_temporary_disability_coverage,
        has_hos_benefit_coverage,
        main_special_diseases_coverage,
        
        annuity_disability_coverage_accident,
        annuity_disability_coverage_disease,
        insurred_extra_dangers
        ,
        // insurred_extra_dangers

      }, { abortEarly: false });
this.constraintValidated(type)
     



    } catch (err: any) {

      this.setState({ step3Errors: err.inner })
    }
  };
  async checkStep4() {
    const { 
      has_waiver_diseases_policy_holder,
      has_waiver_accident_policy_holder,
      policy_holder_extra_dangers
    } = this.state;
    const shebaCodeSchema = yup.object({

      has_waiver_diseases_policy_holder: yup.string().notRequired(),

      has_waiver_accident_policy_holder: yup.string().notRequired(),
      policy_holder_extra_dangers: yup.string().required("خطرات اضافه بیمه گذار اجباری می باشد"),
      

    });
    try {

      await shebaCodeSchema.validate({
        
        has_waiver_diseases_policy_holder,
        has_waiver_accident_policy_holder,
        policy_holder_extra_dangers
        
      }, { abortEarly: false });
      this.setState({ step4Errors: [] })

      this.createInquery();


    } catch (err: any) {
      this.setState({ step4Errors: err.inner })
    }
  };



  async createInquery() {

    const {


      contract_id,


      holder_birthday,
      insured_birthday,
      policy_holder_job_category,
      insured_job_category,
      policy_holder_extra_dangers,
      insurred_extra_dangers,

      // 2
      saveing,
      payment_duration,
      duration,
      adjustment_coefficient_permium,
      decuple_coverages_premium,
      premium_annually,
      // 3
      adjustment_coefficient_death_benefit,
      start_death_asset,
      accident_death_coverage,
      has_cancer_diagnosis,
      cancer_coverage,
      has_supplementary_special_diseases_coverage,
      accident_medical_cost_coverage,
      temporary_and_permanent_disability_coverage,
      has_hos_benefit_coverage,
      main_special_diseases_coverage,

      has_waiver_diseases_policy_holder,
      has_waiver_accident_policy_holder,
      has_temporary_disability_coverage,

      // 4
      annuity_disability_coverage_disease,
      annuity_disability_coverage_accident,

      payment_method,
      medical_extra_rate_percent,
      policy_holder_medical_extra,
      minimum_insurance_premium,

    } = this.state;
    const shebaCodeSchema = yup.object({

    });
    try {

      await shebaCodeSchema.validate({}, { abortEarly: false });

      const response = await service.limitationInquiry.create({
        // holder_birthday,
        //  insured_birthday,
        universal_offer_id:window.location.pathname.split("/")[2] ? window.location.pathname.split("/")[2] : null , 
        contract_id,
        payment_method: payment_method,

        holder_birthday: fixNumbers(holder_birthday.convert()?.format("YYYY-MM-DD")),
        insured_birthday: fixNumbers(insured_birthday.convert()?.format("YYYY-MM-DD")),


        policy_holder_job_category, insured_job_category, policy_holder_extra_dangers,
        insurred_extra_dangers,
        // 2
        duration,
        premium_annually,
        saveing,
        payment_duration,
        adjustment_coefficient_permium,
        decuple_coverages_premium,
        has_waiver_diseases_policy_holder,
        has_waiver_accident_policy_holder,
        // 3
        adjustment_coefficient_death_benefit,
        start_death_asset,
        accident_death_coverage,
        has_cancer_diagnosis,
        cancer_coverage,
        has_supplementary_special_diseases_coverage,
        accident_medical_cost_coverage,
        temporary_and_permanent_disability_coverage,
        has_hos_benefit_coverage,
        main_special_diseases_coverage,
        has_temporary_disability_coverage,
        // 4
        annuity_disability_coverage_disease,
        annuity_disability_coverage_accident,


        medical_extra_rate_percent,
        policy_holder_medical_extra,
        universal_projects: null,
        minimum_insurance_premium
      }
      );
      if (response) {
        this.setState({  result: response?.data?.data, step: 5, isEdited: true })
       
        const guaranteed_reserve_array = []
        const forecast_redeem_value_array = []
        const year_array = []


        for (var i = 0; i < response?.data?.data?.result.length;  i ++) {
          guaranteed_reserve_array.push(response?.data?.data?.result[i].guaranteed_reserve);
        }


        for (var j = 0; j < response?.data?.data?.result.length;  j ++) {
          forecast_redeem_value_array.push(response?.data?.data?.result[j].forecast_redeem_value);
        }


        for (var z = 0; z < response?.data?.data?.result.length; z ++) {
          year_array.push(toFarsiNumber(response?.data?.data?.result[z].term_year));
        }


        this.setState({
          data: {
            labels: year_array,
            family: "Peyda",


            datasets: [
              {

                label: 'رشد پیش بینی شده ',
                data: forecast_redeem_value_array,
                fill: {

                },
                borderColor: "#00AA5B",
              },
              {

                data: guaranteed_reserve_array,
                label: 'رشد تضمینی  ',
                // fill: false,
                borderColor: "#155a9e",
                fill: {

                },
                // backgroundColor:"gradient"
              }

            ]

          },
          options: {
            elements: {
              line: {
                tension: 0.5,
              },
            },
            plugins: {

              // tooltips: {
              //   // callbacks: {
              //   //   title: function(tooltipItem:any, data:any) {
              //   //     return data['labels'][tooltipItem[0]['index']];
              //   //   },
              //   //   label: function(tooltipItem:any, data:any) {
              //   //     return data['datasets'][0]['data'][tooltipItem['index']];
              //   //   },
              //   //   afterLabel: function(tooltipItem:any, data:any) {
              //   //     var dataset = data['datasets'][0];
              //   //     var percent = Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100)
              //   //     return '(' + percent + '%)';
              //   //   }
              //   // },
              //   backgroundColor: '#FFF',
              //   titleFontSize: 16,
              //   titleFontColor: '#0066ff',
              //   bodyFontColor: '#000',
              //   bodyFontSize: 14,
              //   displayColors: false
              // },
              tooltip: {
                backgroundColor: '#ffffff',
                titleFontSize: 16,
                bodyFontColor: '#000000',
                titleFontColor:'#000000',
                titleColor:'#000000',
                bodyFontSize: 14,
                bodyColor:"#000000",
                displayColors: false,
                borderColor:'rgba(0, 0, 0, 0)',
                bodyFont: {
                  family: "Peyda",

                },
                titleFont: {
                  family: "Peyda",

                },
                rtl:true,
                
                callbacks: {
                  // backgroundC
                borderColor:'rgba(0, 0, 0, 0)',
                  // titleFontSize: 16,
                  // titleFontColor: '#0066ff',
                  // bodyFontColor: '#000',
                  // bodyFontSize: 14,
                  // displayColors: false,
                  title: function(context:any) {
                  let title = 'سال';

                
                  if (context[0]?.parsed?.x !== null) {
                      title += toFarsiNumber(numberWithCommas(context[0]?.parsed?.x));
                  }
                  return title;
                  },
                  label: function (context: any) {


                    let label = context.dataset.label || '';

                    if (label) {
                      label += ': ';
                    }
                    if (context?.parsed?.y !== null) {
                      label += toFarsiNumber(numberWithCommas(context?.parsed?.y));
                    }
                    return label;
                  },
                }
              },
              legend: {
                display: false,
                font: {
                  family: "Peyda",
                  lineHeight: 2,
                  useBorderRadius: true,
                  borderRadius: 20,

                },
              }
            },
            scales: {
              // to remove the labels
              x: {
                ticks: {
                  font: {
                    family: "Peyda",
                    weight: 800,
                  },
                },
                // to remove the x-axis grid
                grid: {
                  drawBorder: false,
                  display: false,
                },
              },
              // to remove the y-axis labels
              y: {
                ticks: {
                  beginAtZero: true,
                  callback: function (value: any) {
                    return `${toFarsiNumber(numberWithCommas(value))}  `;
                  },

                  font: {
                    family: "Peyda",
                    weight: 800,
                  },
                },
                grid: {
                  drawBorder: false,
                  display: false,
                },
                // to remove the y-axis grid

              },

            }
          }
        })
 this.props.dispatch(isEqual(this.state.selfsame))

        this.props.dispatch(inqueryDataa(
          {
            // holder_birthday,
            //  insured_birthday,
            contract_id,
            payment_method: payment_method,
    
            holder_birthday: fixNumbers(holder_birthday.convert()?.format("YYYY-MM-DD")),
            insured_birthday: fixNumbers(insured_birthday.convert()?.format("YYYY-MM-DD")),
    
    
            policy_holder_job_category, insured_job_category, policy_holder_extra_dangers,
            insurred_extra_dangers,
            // 2 
            duration,
            premium_annually,
            saveing,
            payment_duration,
            adjustment_coefficient_permium,
            decuple_coverages_premium,
            has_waiver_diseases_policy_holder,
            has_waiver_accident_policy_holder,
            // 3 
            adjustment_coefficient_death_benefit,
            start_death_asset,
            accident_death_coverage,
            has_cancer_diagnosis,
            cancer_coverage,
            has_supplementary_special_diseases_coverage,
            accident_medical_cost_coverage,
            temporary_and_permanent_disability_coverage,
            has_hos_benefit_coverage,
            main_special_diseases_coverage,
            has_temporary_disability_coverage,
            // 4
            annuity_disability_coverage_disease,
            annuity_disability_coverage_accident,
    
    
            medical_extra_rate_percent,
            policy_holder_medical_extra,
        universal_projects: null,
        minimum_insurance_premium,
        

          }
        ));


        //   // toast.success(response?.message);
      }

    } catch (err: any) {
   
      // this.setState({ error: err.inner })
    }
  };
  async constraintValidated(type:boolean) {

    const {


      contract_id,


      holder_birthday,
      insured_birthday,
      policy_holder_job_category,
      insured_job_category,
      // 2
      saveing,
      payment_duration,
      duration,
      adjustment_coefficient_permium,
      decuple_coverages_premium,
      premium_annually,
      // 3
      adjustment_coefficient_death_benefit,
      start_death_asset,
      accident_death_coverage,
      has_cancer_diagnosis,
      cancer_coverage,
      has_supplementary_special_diseases_coverage,
      accident_medical_cost_coverage,
      temporary_and_permanent_disability_coverage,
      has_hos_benefit_coverage,
      main_special_diseases_coverage,

      has_waiver_diseases_policy_holder,
      has_waiver_accident_policy_holder,
      has_temporary_disability_coverage,

      // 4
      annuity_disability_coverage_disease,
      annuity_disability_coverage_accident,

      payment_method,
      medical_extra_rate_percent,
      policy_holder_medical_extra
    } = this.state;
    const shebaCodeSchema = yup.object({

    });
    try {

      await shebaCodeSchema.validate({}, { abortEarly: false });

      const response = await service.limitationInquiry.inqueryConstraintValidated({
        // holder_birthday,
        //  insured_birthday,
        contract_id,
        payment_method: payment_method,

        holder_birthday: fixNumbers(holder_birthday.convert()?.format("YYYY-MM-DD")),
        insured_birthday: fixNumbers(insured_birthday.convert()?.format("YYYY-MM-DD")),


        policy_holder_job_category, insured_job_category,
        //  policy_holder_extra_dangers,
        // insurred_extra_dangers,
        // 2
        duration,
        premium_annually,
        saveing,
        payment_duration,
        adjustment_coefficient_permium,
        decuple_coverages_premium,
        has_waiver_diseases_policy_holder,
        has_waiver_accident_policy_holder,
        // 3
        adjustment_coefficient_death_benefit,
        start_death_asset,
        accident_death_coverage,
        has_cancer_diagnosis,
        cancer_coverage,
        has_supplementary_special_diseases_coverage,
        accident_medical_cost_coverage,
        temporary_and_permanent_disability_coverage,
        has_hos_benefit_coverage,
        main_special_diseases_coverage,
        has_temporary_disability_coverage,
        // 4
        annuity_disability_coverage_disease,
        annuity_disability_coverage_accident,


        medical_extra_rate_percent,
        policy_holder_medical_extra
      }
      );
      if (response) {
        if(response.status === 400){
          toast.error(response?.data?.message);

        }else if (response.status === 200){
          if (type) {


            this.setState({ step: this.state.step + 1 })
          } else {
            this.createInquery();
    
          }
        }else{
          
        }
        this.setState({ step3Errors: [] })
        
       
        //   // toast.success(response?.message);
      }else{

      }

    } catch (err: any) {
   
      // this.setState({ error: err.inner })
    }
  };

  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({
      currentPage: Number(value - 1)
    });

  }
  // "accident_asset_coefficient": 0,
  // "insured_exemption_coverage": 0,
  async checkStepMobile1(type: boolean) {

    const {contract_id, holder_birthday, policy_holder_job_category } = this.state;
    const shebaCodeSchema = yup.object({
      holder_birthday: yup.string().required("تاریخ تولد اجباری می باشد"),
      policy_holder_job_category: yup.string().required("شغل اجباری می باشد"),
      contract_id: yup.string().when('$condition', (condition, schema) =>
        contract_id !== "" ?
          schema.required("شماره قرارداد اجباری می‌باشد").min(3, "شماره قرارداد نمی‌تواند کمتر از 3 کاراکتر باشد").max(10, "شماره قرارداد نمی‌تواند بیشتر از 10 کاراکتر باشد") : schema
      ),
      // policy_holder_extra_dangers: yup.string().required("خطرات اضافه بیمه گذار اجباری می باشد"),
    });
    try {
      await shebaCodeSchema.validate({ holder_birthday,contract_id, policy_holder_job_category }, { abortEarly: false });
      this.setState({ step1Errors: [] })

    if (!window.location.pathname.split("/")[2]) {
      if (this.state.selfsame) {
        if (type) {
          this.getLimitationInquery();
          // this.setState({ step: this.state.step + 1 })
        } else {
          this.createInquery();
        }
      } else {
        if (type) {
          this.setState({ handleMobileStep1: true })
        } else {
          this.createInquery();
        }
      }
    } else {
      if (this.state.selfsame) {
        this.setState({ step: this.state.step + 1 })
      } else {
        this.setState({ handleMobileStep1: true })
      }
      }

    } catch (err: any) {

      this.setState({ step1Errors: err.inner })
    }
  };
  async checkStepMobile2(type: boolean) {
    const { insured_job_category , insured_birthday } = this.state;
    const shebaCodeSchema = yup.object({
      insured_birthday: yup.string().required("تاریخ تولد اجباری می باشد"),
      insured_job_category: yup.string().required("شغل اجباری می باشد"),
      // insurred_extra_dangers: yup.string().required("خطرات اضافه بیمه شده اجباری می باشد"),
    });
    try {
      await shebaCodeSchema.validate({ insured_birthday, insured_job_category }, { abortEarly: false });
      this.setState({ step1Errors: [] })
      if (!window.location.pathname.split("/")[2]) {
      if (type) {
        this.getLimitationInquery();
        // this.setState({ step: this.state.step + 1 })
      } else {
        this.createInquery();
      }
    } else {
          this.setState({ step: this.state.step + 1 })
      }

    } catch (err: any) {
      this.setState({ step1Errors: err.inner })
    }
  };


  handleChangeCancer = (e: any) => {

    this.setState({ cancer_coverage: e })
    if (e === 0) {
      this.setState({ has_cancer_diagnosis: false })

    }
  }
  handleChangeMainSpecial = (e: any) => {
    this.setState({ main_special_diseases_coverage: e })
    if (e === 0) {
      this.setState({ has_supplementary_special_diseases_coverage: false })

    }
  }
  changeAccidentDeathCoverage = (e:any) => {
    const {limitationInquiry} = this.state
    this.setState({ accident_death_coverage: e })
    if(e===0){

      this.setState({  accident_medical_cost_coverage: 0, temporary_and_permanent_disability_coverage: 0,has_temporary_disability_coverage: false, has_hos_benefit_coverage:false})
    }else{
      this.setState({  accident_medical_cost_coverage: limitationInquiry.filter((item: { name: string; }) => item.name === "accident_medical_cost_coverage")[0]?.default,
      temporary_and_permanent_disability_coverage:  limitationInquiry.filter((item: { name: string; }) => item.name === "temporary_and_permanent_disability_coverage")[0]?.default,
      has_temporary_disability_coverage: limitationInquiry.filter((item: { name: string; }) => item.name === "has_temporary_disability_coverage")[0]?.default,
       has_hos_benefit_coverage:limitationInquiry.filter((item: { name: string; }) => item.name === "has_hos_benefit_coverage")[0]?.default,})
    }
  }
  async downloadPdf() {
    this.setState({ base64Loading: true });
    const {
      contract_id,
      holder_birthday,
      insured_birthday,
      policy_holder_job_category,
      insured_job_category,
      policy_holder_extra_dangers,
      insurred_extra_dangers,
      // 2
      saveing,
      payment_duration,
      duration,
      adjustment_coefficient_permium,
      decuple_coverages_premium,
      premium_annually,
      // 3
      adjustment_coefficient_death_benefit,
      start_death_asset,
      accident_death_coverage,
      has_cancer_diagnosis,
      cancer_coverage,
      has_supplementary_special_diseases_coverage,
      accident_medical_cost_coverage,
      temporary_and_permanent_disability_coverage,
      has_hos_benefit_coverage,
      main_special_diseases_coverage,
      has_waiver_diseases_policy_holder,
      has_waiver_accident_policy_holder,
      has_temporary_disability_coverage,
      // 4
      annuity_disability_coverage_disease,
      annuity_disability_coverage_accident,
      payment_method,
      medical_extra_rate_percent,
      policy_holder_medical_extra
    } = this.state;
    try {

      const response = await axios.post(
        `${AppConstants.base_url_api}universalOfferreport`,
        {
        contract_id,
        payment_method: payment_method,

        holder_birthday: fixNumbers(holder_birthday.convert()?.format("YYYY-MM-DD")),
        insured_birthday: fixNumbers(insured_birthday.convert()?.format("YYYY-MM-DD")),
        policy_holder_job_category, insured_job_category, policy_holder_extra_dangers,
        insurred_extra_dangers,
        // 2
        duration,
        premium_annually,
        saveing,
        payment_duration,
        adjustment_coefficient_permium,
        decuple_coverages_premium,
        has_waiver_diseases_policy_holder,
        has_waiver_accident_policy_holder,
        // 3
        adjustment_coefficient_death_benefit,
        start_death_asset,
        accident_death_coverage,
        has_cancer_diagnosis,
        cancer_coverage,
        has_supplementary_special_diseases_coverage,
        accident_medical_cost_coverage,
        temporary_and_permanent_disability_coverage,
        has_hos_benefit_coverage,
        main_special_diseases_coverage,
        has_temporary_disability_coverage,
        // 4
        annuity_disability_coverage_disease,
        annuity_disability_coverage_accident,
        medical_extra_rate_percent,
        policy_holder_medical_extra,
        universal_projects: null,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:  `${Cookies.get('acto')}`,
          },
          responseType: "blob", 
        }
      );
      if (response) {
      

      this.setState({ base64Loading: false })
      try {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    // this.setState({ base64Data: url })
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "report.pdf"); // نام فایل
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
      } catch (error) {
        console.error("خطایی رخ داد:", error   );
        this.setState({ base64Loading: false })
      } 
      }
    } catch (err: any) {
   
    }
  };
}

export default InqueryController;


